// One definition of "every item on this quote carries a price", used by the
// assessment page to gate the money-committing actions (Quote Ready, Part-Ex,
// Consignment). Reject is NOT gated — rejecting commits no price to the customer.
//
// The signal is the SELL price (SP) only — NOT SP-or-BP like everyItemPriced
// (pricingStatus.js). SP is the engine's market/resale price: a NO_MARKET_DATA
// park leaves it at £0 and a never-priced line leaves it null, both of which mean
// "not really priced". BP is deliberately ignored so an operator can price a buy
// into £0 (a throw-in / no-buy line) on an otherwise-priced item without tripping
// the gate. Number(sp) > 0 catches null, undefined, '' and 0 alike.
//
// A quote with NO items, or ANY item without a sell price, is not fully priced:
// firing an offer, part-ex or consignment on it would commit a £0-priced line to
// the customer. Those actions are blocked until every item has an SP (or the quote
// is re-run through the engine). Reject commits no price, so it is never blocked.
export const itemIsPriced = (it) => Number(it?.sp) > 0;

export function hasUnpricedItem(items) {
    const list = Array.isArray(items) ? items : [];
    return list.length === 0 || list.some(it => !itemIsPriced(it));
}
